<div
  class="text-center h-100 container-fluid d-flex justify-content-center align-items-center"
>
  <div class="row align-items-center h-100">
    <div class="col-12">
      <h2>
        페이지가 존재하지 않습니다, 클릭 <a routerLink="/">여기</a> 홈페이지로
        돌아가기
      </h2>
      <h2>
        Unrecognized URI, Click <a routerLink="/">HERE</a> Back to Homepage
      </h2>
      <h2>頁面不存在，點擊 <a routerLink="/">這裡</a> 回到首頁</h2>
      <h2>
        ページが存在しません。<a routerLink="/">ここ</a>
        をクリックしてページトップへ戻る
      </h2>
    </div>
  </div>
</div>
